import React, { Suspense, lazy, useState, useEffect } from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import history from "./features/history/history";
import { ProtectedRoute } from "./ProtectedRoute";
import { getLoggedInUser, getUserType } from "./api/accounts";
import { getUserDetails } from "./api/users";
import AuthContext from "./context/AuthContext";
import logoGif from "./features/assets/loadingGif.webp";
import ScrollToTop from "./features/ui/ScrollToTop";
import "./App.css";

// const Home = lazy(() => import("./features/static/Home"));
// const Navbar = lazy(() => import("./features/ui/Navbar"));
// const Login = lazy(() => import("./features/accounts/Login"));
// const Register = lazy(() => import("./features/accounts/Register"));
// const ForgetPassword = lazy(() => import("./features/accounts/ForgetPassword"));
// const Profile = lazy(() => import("./features/users/Profile"));
// const RequestStatusPage = lazy(() => import("./features/requests/RequestStatusPage"));
// const Dashboard = lazy(() => import("./features/users/Dashboard"));
// const ActiveRequestList = lazy(() => import("./features/requests/ActiveRequestList"));
// const AboutUs = lazy(() => import("./features/static/AboutUs"));
// const Footer = lazy(() => import("./features/static/Footer"));
// const EditPassword = lazy(() => import("./features/users/EditPassword"));
// const donut =lazy(() => import("./features/ui/donut"));

import Navbar from "./features/ui/Navbar";
import Login from "./features/accounts/Login";
import Register from "./features/accounts/Register";
import Profile from "./features/users/Profile";
import RequestStatusPage from "./features/requests/RequestStatusPage";
import Dashboard from "./features/users/Dashboard";
import ActiveRequestList from "./features/requests/ActiveRequestList";
import Home from "./features/static/Home";
import Footer from "./features/static/Footer";
import AboutUs from "./features/static/AboutUs";

import ForgetPassword from "./features/accounts/ForgetPassword";
import EditPassword from "./features/users/EditPassword";
import donut from "./features/ui/donut";
// import requesterCards from "./features/users/requesterCards";

function App() {
  const [authStatusLoaded, setAuthStatusLoaded] = useState(false); // used to wait if any user is logged in
  const [user, setUser] = useState(null);

  // Setting user state if user logged in.
  useEffect(() => {
    getLoggedInUser()
      .then(async (user) => {
        // Setting user type
        const userType = await getUserType(user.uid);
        let details;
        if (userType == "donor" || userType == "requester") {
          details = await getUserDetails(user.uid, userType);
        }
        setUser({ ...user, userType, details });
        setAuthStatusLoaded(true);
      })
      .catch(() => {
        setUser(null);
        setAuthStatusLoaded(true);
      });
  }, []);

  // if authentication has not been loaded yet
  if (!authStatusLoaded) {
    return (
      <div>
        <img className="loading" src={logoGif} />
        <p className="loading-text">Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <Router history={history}>
        <div>
          <ScrollToTop />
          <AuthContext.Provider value={{ user }}>
            {/* <Suspense fallback={<div>Loading...</div>}> */}
              <Navbar />
              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/login" component={Login} />
                <Route path="/register" component={Register} />
                <Route path="/donut" component={donut} />
                <Route path="/request-status/" component={RequestStatusPage} />
                <Route path="/aboutus" component={AboutUs} />
                <Route path="/forget-password" component={ForgetPassword} />
                {/* <ProtectedRoute path="/cards" component={requesterCards} /> */}
                <ProtectedRoute path="/requests" component={ActiveRequestList} />
                <ProtectedRoute path="/profile" component={Profile} />
                <ProtectedRoute path="/password" component={EditPassword} />
                <ProtectedRoute path="/dashboard" component={Dashboard} />
                <Route
                  path="*"
                  component={() => {
                    return <Redirect to="/" />;
                  }}
                />
              </Switch>
            {/* </Suspense> */}
          </AuthContext.Provider>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
